import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthModal from "@/components/AuthModal";
import PricingModal from "@/components/PricingModal";
import IntroOfferModal from "@/components/IntroOfferModal";
import Studio from "@/pages/Studio";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
          <AuthModal />
          <PricingModal />
          <IntroOfferModal />
          <Toaster
            theme="dark"
            position="bottom-center"
            toastOptions={{
              style: {
                borderRadius: "0px",
                background: "#1A1A1A",
                border: "1px solid #27272a",
                color: "#fff",
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "13px",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
